<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-sales"
      ok-only
      centered
      size="lg"
      :title="$t('pharmacy.SaleOfPoint-Sales')"
      @ok="reloadWindow()"
      @hide="reloadWindow()"
    >
      <b-card-text class="d-flex justify-content-center">
        <h2>
          {{ $t("pharmacy.SaleOfPoint-salesDone") }}
        </h2>
      </b-card-text>
    </b-modal>
    <b-card :title="$t('warehouse.salesOfPoint-items')">
      <ScanBarcode @barcode="addToItemsList($event)" />
    </b-card>
    <b-card :title="$t('warehouse.item')" v-if="showTables">
      <b-table
        :items="this.items"
        responsive
        :fields="itemsCloumns"
        primary-key="id"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
        v-if="!loading"
      >
        <template #cell(expiry_date)="data">
          <b-badge pill :variant="getBadgeVariant(data.item.expiry_date)">{{
            data.item.expiry_date
          }}</b-badge>
        </template>
        <template #cell(changeable-quantity)="data">
          <b-form-input
            type="number"
            id="Quantity"
            v-model="data.item.editableQuantities"
            :placeholder="$t('warehouse.quantity')"
          />
        </template>
        <template #cell(unit_price)="data">
          <b-form-input
            type="number"
            id="Price"
            v-model="data.item.sell_price"
            :placeholder="$t('warehouse.price')"
          />
        </template>
        <template #cell(total_price)="data">
          <span>{{
            (
              data.item.editableQuantities * data.item.sell_price
            ).toLocaleString()
          }}</span>
        </template>
        <template #cell(actions)="data">
          <!-- <b-button
            class="mt-2"
            ref="myButton"
            pill
            size="sm"
            variant="outline-primary"
            @click="addToStockOuts(data.item)"
          >
            {{ $t("common.add") }}
          </b-button> -->
          <b-button size="sm" variant="danger" @click="removeItem(data.item)"
            >X</b-button
          >
        </template>
      </b-table>
      <div class="d-flex mt-2">
        <h3>{{ $t("common.totalPrice") }}:</h3>
        <h4 class="ml-2">{{ totalPrice.toLocaleString() }}</h4>
      </div>
      <template v-if="loading">
        <div>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner :label="$t('common.loading')" />
          </div>
        </div>
      </template>
      <div class="d-flex justify-content-end">
        <b-button
          :disabled="items.length === 0"
          class="mt-2"
          ref="myButton"
          variant="primary"
          @click="submitItem"
        >
          {{ $t("common.submit") }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BCardText,
  BBadge,
  BModal,
  BFormTextarea,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
const CategoryModal = () => import("@/components/warehouse/CategoryModal.vue");
const ScanBarcode = () => import("@/views/warehouse/ScanBarcode.vue");

export default {
  components: {
    BCard,
    BFormTextarea,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    Datepicker,
    BBadge,
    BCardText,
    CategoryModal,
    BModal,
    ScanBarcode,
  },
  data() {
    return {
      categoryFilter: {
        name: "",
        id: "",
      },
      editableQuantities: {},

      isBarCodeStep: true,
      showTables: false,
      loading: true,
      items: [],
      ItemId: null,
      employee_id: "",
      patient_card_id: this.$route.params.patient_card_id,
      date: this.formatExpDate(Date.now()),
      description: "",
      stockoutForm: {
        item_id: "",
        warehouse_id: "",
        batch_no: "",
        balance_id: "",
        expiry_date: "",
        quantity: "",
        unit_price: "",
      },
      itemsCloumns: [
        { key: "item.name", label: this.$t("common.name"), sortable: true },
        {
          key: "category.name",
          label: this.$t("warehouse.one-category"),
          sortable: true,
        },
        {
          key: "quantity",
          label: this.$t("warehouse.quantity"),
          sortable: true,
        },
        {
          key: "batch_no",
          label: this.$t("warehouse.batch-no"),
          sortable: true,
        },
        {
          key: "expiry_date",
          label: this.$t("warehouse.exp-date"),
          sortable: true,
        },
        // {
        //   key: "quantity",
        //   label: this.$t("warehouse.quantity"),
        //   sortable: true,
        // },
        {
          key: "changeable-quantity",
          label: this.$t("warehouse.change-quantity"),
          sortable: true,
        },
        {
          key: "unit_price",
          label: this.$t("warehouse.price"),
          sortable: true,
        },
        {
          key: "total_price",
          label: this.$t("warehouse.total_price"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      tableColumns: [
        { key: "item_id.", label: this.$t("common.name"), sortable: true },
        {
          key: "batch_no",
          label: this.$t("warehouse.batch-no"),
          sortable: true,
        },
        {
          key: "quantity",
          label: this.$t("warehouse.quantity"),
          sortable: true,
        },
        {
          key: "price",
          label: this.$t("warehouse.price"),
          sortable: true,
        },
        {
          key: "expiry_date",
          label: this.$t("warehouse.exp-date"),
          sortable: true,
        },
        {
          key: "total_price",
          label: this.$t("warehouse.total_price"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      stockouts: [],
      params: {
        form: {},
        path: "",
      },
    };
  },
  computed: {
    totalPrice() {
      return this.items.reduce(
        (sum, item) => sum + item.sell_price * item.editableQuantities,
        0
      );
    },
  },
  watch: {
    editableQuantities: {
      handler() {
        console.log(this.editableQuantities, `editableQuantities`);
      },
      deep: true,
    },
  },
  methods: {
    getBadgeVariant(date) {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();

      const itemDate = new Date(date);
      const itemMonth = itemDate.getMonth();
      const itemYear = itemDate.getFullYear();

      return itemMonth === currentMonth && itemYear === currentYear
        ? "danger"
        : "success";
    },
    addToStockOuts(item) {
      item.expiry_date = this.formatExpDate(item.expiry_date);
      item.item_id = item.item.name;
      item.warehouse_id = item.warehouse.name;
      item.batch_no = item.batch_no;
      item.balance_id = item.id;
      item.barcode = item.barcode;
      item.price = item.sell_price;
      item.total_price = item.sell_price * item.quantity;

      // Find if the item already exists in stockouts based on the id
      const existingStockOutItem = this.stockouts.find(
        (stockout) => stockout.id === item.id
      );

      if (existingStockOutItem) {
        // If the item exists, increase the quantity
        existingStockOutItem.quantity += this.editableQuantities[item.id];
        // Update total price based on new quantity
        existingStockOutItem.total_price =
          existingStockOutItem.price * existingStockOutItem.quantity;
      } else {
        // If item doesn't exist, push it as a new entry with initial quantity
        const stockoutItem = {
          ...item,
          quantity: this.editableQuantities[item.id], // Use editable quantity
        };
        stockoutItem.total_price = stockoutItem.price * stockoutItem.quantity; // Calculate total price
        this.stockouts.push(stockoutItem);
      }
    },
    reloadWindow() {
      window.location.reload();
    },
    async addToItemsList(barcode) {
      this.loading = true;

      const url = `/balance?filter[barcode]=${barcode}&sort=expiry_date&include=category,item,warehouse&filter[type]=pharmacy`;

      await this.getList(url);

      if (this.all_data.data.length > 0) {
        this.all_data.data.forEach((item) => {
          // Check if item already exists in the array
          const existingItem = this.items.find(
            (existing) => existing.id === item.id
          );

          if (existingItem) {
            // If item exists, increase its quantity by 1
            if (parseInt(existingItem.quantity) > parseInt(existingItem.editableQuantities)) {
              existingItem.editableQuantities = parseInt(existingItem.editableQuantities) + 1;
            } else {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Item (${existingItem.item.name}) quantity : ${existingItem.quantity} is less than editable quantity : ${existingItem.editableQuantities}`,
                  variant: "danger",
                },
              });
            }
          } else {
            // If item does not exist, initialize quantity to 1 and add to list
            item.editableQuantities = 1;
            this.items.push(item);
          }
        });

        this.isBarCodeStep = false;
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `${this.$t("common.item-not-found")}`,
            variant: "danger",
            timeout: 10000,
          },
        });
      }

      this.showTables = true;
      this.loading = false;
    },
    removeItem(item) {
      this.items = this.items.filter((stokout) => stokout !== item);
    },

    showScanner() {
      (this.isBarCodeStep = true), (this.showTables = false);
    },
    formatExpDate(expDate) {
      // Create a new Date object from the selected date
      const date = new Date(expDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1); // getMonth() is zero-based
      let day = "" + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },

    async changeBalanceId() {
      this.loading = true;
      let url = `/balance?&filter[id]=${this.stockoutForm.balance_id}&include=item,category,warehouse`;

      await this.getList(url);
      this.currentBalance = this.all_data.data[0];
      this.stockoutForm.quantity = this.currentBalance.quantity;
      this.stockoutForm.warehouse_id = this.currentBalance.warehouse_id;
      this.stockoutForm.expiry_date = this.currentBalance.expiry_date;
      this.stockoutForm.unit_price = this.currentBalance.unit_price;
      this.loading = false;
    },

    submitItem() {
      this.date = this.formatExpDate(this.date);
      console.log(this.items);
      const salesItems = this.items.map((stock) => ({
        quantity: stock.editableQuantities,
        price: stock.sell_price,
        balance_id: stock.id,
      }));

      this.params.form = {
        date: this.date,
        stockouts: salesItems,
      };
      this.params.path = "/stockout";
      this.$store
        .dispatch("create", this.params)
        .then((response) => {
          this.$bvModal.show("modal-sales");
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Created",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.stockouts = [];

            for (const item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "validation error",
                  variant: "danger",
                  text: error.response.data[item],
                },
              });
            }
          }
        });
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 100vh !important; /* Adjust based on your needs */
  overflow: visible; /* Ensure the container doesn't scroll */
}
.b-table,
.table-container {
  overflow: visible !important; /* Force the table and container not to scroll */
}
.no-scroll-table {
  overflow: visible !important; /* Prevent scrolling within the table */
}
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
